import { AFFILIATE_SOURCE_PATHS } from '@wlb/shared/constants';

/** Affiliate portal paths, so no screen hard-codes a route string. */
export const AFFILIATE_ROUTES = {
  LANDING: '/affiliate',
  SIGN_IN: '/affiliate/signin',
  SIGN_UP: '/affiliate/signup',
  SIGN_UP_SUCCESS: '/affiliate/signup/success',
  FORGOT_PASSWORD: '/affiliate/forgot-password',
  VERIFICATION_CODE: '/affiliate/verification-code',
  RESET_PASSWORD: '/affiliate/reset-password',
  PASSWORD_RESET_SUCCESS: '/affiliate/password-reset-success',
  DASHBOARD: '/affiliate/dashboard',
  PROFILE: '/affiliate/profile',
} as const;

/**
 * True for every page of the affiliate portal, including the campaign entry
 * points that redirect into it.
 *
 * The portal is a public marketing surface with its own fixed palette, so it
 * renders light whatever the member app's theme is; `ThemeApplier` asks this
 * before mirroring the preference onto `<html>`. Matching on the prefix rather
 * than the route table keeps a future `/affiliate/...` page covered by default,
 * and the explicit `/affiliate` case stops a member route that merely starts
 * with the same letters from being caught.
 */
export const isAffiliateSurfacePath = (pathname: string): boolean => {
  const path = pathname.replace(/\/+$/, '') || '/';
  if (path === AFFILIATE_ROUTES.LANDING || path.startsWith(`${AFFILIATE_ROUTES.LANDING}/`)) {
    return true;
  }
  return AFFILIATE_SOURCE_PATHS.some(source => path === `/${source}`);
};
